const theme = {
  detailsTitleTextColor: '#ffffff',
  detailsMetadataTextColor: 'rgba(255, 255, 255, 0.7)',
  secondaryActiveColor: '#ff994f',
  playerProgressBackground: 'rgba(255, 255, 255, 0.25)',
  playerProgressBuffer: 'rgba(255, 255, 255, 0.25)',
  playerProgressElapsed: 'rgba(255, 255, 255, 1)',
  playerCurrentPosition: 'rgba(255, 255, 255, 1)',
  playerTime: '#ffffff',
  playerButtonBg: 'rgba(255, 255, 255, 0.15)',
  modalOverlayColor: '#000',
  transparentModalOverlayColor: 'rgba(0, 0, 0, 0.8)',
  backgroundColor: '#18181B',
  playerBackground: '#000000',
  menuBackground: '#26262C',
  overlayColor: 'rgba(0, 0, 0,  0.5)',
  defaultColor: '#ffffff',
  epgBorderColor: 'rgba(255, 255, 255, 0.75)',
  epgTimeColor: '#F4F4F4',
  epgFocusColor: '#FAFF00',
  mainTextColor: '#cccccc',
  secondaryTextColor: '#9F9F9F',
  activeColor: '#FAFF00',
  focusedTextColor: '#000000',
  imagePlaceholder: '#26262C',
  iconDefaultColor: '#9F9F9F',
  submenuActiveColor: '#444444',
  buttonBorderColor: 'rgba(159, 159, 159, 0.5)',
  backgroundLoaderColor: 'rgba(38, 38, 38, 0.9)',
  invalidInput: '#ff3333',
  catchUpLabelColor: '#1da253',
  devider: '#4B4B4B',
  epgBackground: '#18181B',
};

export type ThemeType = typeof theme;

export default theme;
